import { Controller } from "@hotwired/stimulus";

// Client-side All / Following / Trusted filter for the suggested-professionals
// panel (M10). Each list item carries data-following / data-trusted; the tabs
// toggle item visibility without a server round-trip.
export default class extends Controller {
  static targets = ["tab", "item", "empty"];

  select(event) {
    const filter = event.currentTarget.dataset.filter;

    this.tabTargets.forEach((tab) =>
      tab.classList.toggle("active", tab.dataset.filter === filter)
    );

    let visible = 0;
    this.itemTargets.forEach((item) => {
      const show =
        filter === "all" ||
        (filter === "following" && item.dataset.following === "true") ||
        (filter === "trusted" && item.dataset.trusted === "true");
      item.hidden = !show;
      if (show) visible += 1;
    });

    if (this.hasEmptyTarget) {
      this.emptyTarget.classList.toggle("d-none", visible > 0);
    }
  }
}
